import React, { useState } from 'react';
import { apiConstants, postMultipart } from '../common/constants';
import PageTitle from '../components/PageTitle';
import { Box, Button, Card, CardContent, Grid, Typography } from '@mui/material';
import { FormProvider, RHFFileField } from '../common/hook-form';
import { LoadingButton } from '@mui/lab';
import { DownloadOutlined, UploadFileOutlined } from '@mui/icons-material';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useSnackbar } from 'notistack';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { MerchantFilterCached } from '../common/ProshipFormComponents';

const BulkDownloadPOD = () => {
    const methodsBulkUpload = useForm({
        resolver: yupResolver(Yup.object().shape({
            orderFile: Yup.mixed().required("Please Select a File"),
        })),
        defaultValues: {
            orderFile: null
        }
    });
    const { handleSubmit: handleSubmitBulkUpload, reset } = methodsBulkUpload;
    const [fileLink, setFileLink] = useState([])
    const [isUploadingFile, setIsUploadingFile] = useState(false)
    const [zipLink, setZipLink] = useState([])
    const [mergedPdf, setMergedPdf] = useState([])
    const { enqueueSnackbar } = useSnackbar();

    const onSubmitBulkUpload = async (data) => {
        setIsUploadingFile(true)
        try {
            let form = new FormData()
            form.append('file', data.orderFile[0])
            await postMultipart(`${apiConstants.BULK_DOWNLOAD_POD}?isMerchantPannel=true&merchantoId=${data.merchant}`, form).then(response => {
                if (response.data && response.data['excel'] && response.data['excel'].startsWith('https')) {
                    setFileLink(response.data['excel']);
                    setZipLink(response.data['zipFile'])
                    setMergedPdf(response.data['mergedPdf'])
                    enqueueSnackbar("Successfully Uploaded!", { variant: 'success' })
                    reset({
                        orderFile: null
                    })
                }
                else {
                    enqueueSnackbar(response?.data[3962], { variant: 'error' })
                }
            }).catch(err => { console.error(err); setIsUploadingFile(false); enqueueSnackbar(err?.response?.data?.message || "Error uploading file", { variant: 'error' }) });
        } catch (err) {
            const message = err?.response?.data?.message || err.message
            enqueueSnackbar(message || "Error uploading file", { variant: 'error' })
        }
        setIsUploadingFile(false)
    }

    return (
        <>
            <PageTitle>Bulk POD Download</PageTitle>
            <Card>
                <CardContent>
                    <FormProvider methods={methodsBulkUpload} onSubmit={handleSubmitBulkUpload(onSubmitBulkUpload)}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <MerchantFilterCached />
                            </Grid>
                            <Grid item xs={12}>
                                <RHFFileField name="orderFile" accept={['xlsx']} />
                            </Grid>
                            <Grid item xs={12}>
                                <LoadingButton
                                    startIcon={<FileUploadIcon />}
                                    type="submit"
                                    loading={isUploadingFile}
                                    variant="contained"
                                    color="warning"
                                    size="medium">
                                    Upload
                                </LoadingButton>
                                {/* <a className="btn btn-link btn-download" style={{ 'marginLeft': '16px' }} href="" download="Order Upload Sample"><img src="img/download.svg" width="22" alt="" /></a> */}
                                {fileLink?.length === 0 &&
                                    <Button variant="contained" className="btn-download" style={{ marginLeft: '16px', textDecoration: 'none' }} href={"https://djslb35m04okm.cloudfront.net/generate_labels.csv"}
                                        download="Order Upload Sample"
                                        startIcon={<UploadFileOutlined style={{ fontSize: 22 }} />}
                                    >
                                        Sample Download
                                    </Button>
                                }
                                {fileLink?.length > 0 &&
                                    // <a className="btn btn-link btn-download" style={{ 'marginLeft': '16px' }} href={fileLink} download="Order Upload Sample"><img src="img/download.svg" width="22" alt="" />Download Labels Excel </a>
                                    <Button variant="contained" className="btn-download" style={{ marginLeft: '16px', textDecoration: 'none' }} href={fileLink}
                                        download="Download Excel"
                                        startIcon={<DownloadOutlined style={{ fontSize: 22 }} />}
                                    >
                                        Download Excel
                                    </Button>

                                }
                                {zipLink?.length > 0 &&
                                    // <a className="btn btn-link btn-download" style={{ 'marginLeft': '16px' }} href={zipLink} download="Order Upload Sample"><img src="img/download.svg" width="22" alt="" />Download Zip file </a>
                                    <Button variant="contained" className="btn-download" style={{ marginLeft: '16px', textDecoration: 'none' }} href={zipLink}
                                        download="Download Zip"
                                        startIcon={<DownloadOutlined style={{ fontSize: 22 }} />}
                                    >
                                        Download Zip
                                    </Button>
                                }
                                {mergedPdf?.length > 0 &&
                                    // <a className="btn btn-link btn-download" style={{ 'marginLeft': '16px' }} href={zipLink} download="Order Upload Sample"><img src="img/download.svg" width="22" alt="" />Download Zip file </a>
                                    <Button variant="contained" className="btn-download" style={{ marginLeft: '16px', textDecoration: 'none' }} href={mergedPdf}
                                        download="Download PDF"
                                        target="_blank"
                                        startIcon={<DownloadOutlined style={{ fontSize: 22 }} />}
                                    >
                                        Download Merged PDF
                                    </Button>
                                }
                            </Grid>
                            <Typography sx={{ mt: 2, ml: 2 }} component='span' color='error' variant='body1'> You can only upload up to 1500 AWBs at once.</Typography>
                        </Grid>
                    </FormProvider>
                </CardContent>
            </Card>
        </>
    )
}
export default BulkDownloadPOD